import { Component, OnDestroy } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { FormControl, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { OtpComponent } from 'npx-arc-ui/otp-input';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

enum Code{
  EMAIL = 1,
  GOOGLE_AUTH,
  SMS = 3
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule
    , MatButtonModule
    , MatInputModule
    , RouterModule
    , ReactiveFormsModule
    , MatSelectModule
    , MatIconModule
    , CommonModule
    , OtpComponent
  ]
})
export class ForgotPasswordComponent implements OnDestroy{
  readonly passwordRules = [
    'Entre 10 y 50 caracteres',
    'Al menos un carácter especial',
    'Al menos un número',
    'Al menos una letra mayúscula',
    'Al menos una letra minúscula'
  ];
  largoCodigo: number = 5;
  form: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    codeSet: new FormControl("", [Validators.required]),
    signingCode: new FormControl("", [Validators.required]),
    newpass: new FormControl("", [Validators.required]),
    repnewpass: new FormControl("", [Validators.required]),
  })
  public mostrarValidator: boolean = false;
  public isHideNew: boolean = false;
  public isHideRep: boolean = false;
  public passMatch!: boolean;
  formChangedForgot = false;
  formChangedForgotConfirm = false;
  private subscription: Subscription;

  constructor(public appStateService: AppStateService) { 
      this.subscription = this.form.get('codeSet')!
      .valueChanges
      .subscribe(codigo =>{
        this.largoCodigo= Number(codigo) == Code.GOOGLE_AUTH ? 6 : 5;
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  logOut(){
    localStorage.clear();
    this.formChangedForgotConfirm = false;
    this.appStateService.router.navigateByUrl('');
  }

  get Email(): string{
    return this.form.get('email')?.value || '';
  }
  get CodeSet(): string{
    return this.form.get('codeSet')?.value || '';
  }
  get SigningCode(){
    return this.form.get('signingCode');
  }
  get NewPass():string{
    return this.form.get('newpass')?.value || '';
  }
  get RepNewPass():string{
    return this.form.get('repnewpass')?.value || '';
  }
  
  sendForgotEmail(){
    if (this.form.get('email')?.invalid || this.appStateService.loading) return;
    this.appStateService.loading = true;
    this.appStateService.UserService
    .CheckUser(this.Email)
    .subscribe(({success}) => {
      if(success){
        this.formChangedForgot = true;
      }
    })
  }

  SenCode(){
    if (this.form.get('codeSet')?.invalid || this.appStateService.loading) return;
    if(Number(this.CodeSet) == Code.GOOGLE_AUTH){
      this.formChangedForgotConfirm = true;
    }else{
      this.appStateService.UserService
      .SendCode(this.CodeSet,this.Email)
      .subscribe((({success}) =>{
        if(success){
          if (!!this.Email.length) {
            this.formChangedForgotConfirm = true;
          }
        }
      }));
    }
  }

  HandlerOTPChange(otp: string) {
    this.SigningCode?.patchValue(otp);
  }

  isGoogleAuth(){
    return Number(this.CodeSet) == Code.GOOGLE_AUTH
  }

  isEmailAuth(){
    return Number(this.CodeSet) == Code.EMAIL
  }

  isSMSAuth(){
    return Number(this.CodeSet) == Code.SMS
  }

  hasError(index: number): boolean{
    if(!this.NewPass.length) return true;
    const value  = this.NewPass;
    const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
    switch (index) {
      case 1:
        return String(value).length < 10 || String(value).length > 50

      case 2:
        return !String(value).match(patterns[patterns.length - 1]) || false

      case 3:
        return !String(value).match(patterns[patterns.length - 2]) || false

      case 4:
        return !String(value).match(patterns[patterns.length - 3]) || false

      case 5:
        return !String(value).match(patterns[patterns.length - 4]) || false

      default:
        return false
    }
  }

  get isSamePass(){
    return (!!this.NewPass.length && !!this.RepNewPass.length) && this.NewPass===this.RepNewPass
  };

  VerifyForgotYourPasswordAsync(){
    if (this.onValidation || this.appStateService.loading) return;
    const { value } = this.form
    this.appStateService.UserService.VerifyForgotYourPasswordAsync(value)
  }

  get onValidation(): boolean{
    const 
    code = this.SigningCode?.value.length === this.largoCodigo,
    isSame = this.isSamePass,
    hasError = [1,2,3,4,5].map(c => this.hasError(c)).filter(Boolean),
    end = code && isSame && !hasError.length;
    return !end;
  }

  onContinue(): void {
    if (this.formChangedForgotConfirm) this.VerifyForgotYourPasswordAsync();
    else if (this.formChangedForgot) this.SenCode();
    else this.sendForgotEmail();
  }


}
